module.exports = __webpack_public_path__ + "static/media/main-list-photo.ccfa7942.png";